module.exports = __webpack_public_path__ + "img/receipt.20234669.svg";